// extracted by css-extract-rspack-plugin
export default {"Wrapper":"XHmXP","Main":"qzpQu","Sidebar":"u6vXz","Content":"uoJCO"};